import { Alert, Box, Button, Typography } from '@mui/material';
import { isRouteErrorResponse, useNavigate, useRouteError } from 'react-router-dom';

/** Root error boundary for the router: shows the real message/stack (helps diagnosing prod builds). */
export function RouteError() {
  const error = useRouteError();
  const navigate = useNavigate();
  const message = isRouteErrorResponse(error)
    ? `${error.status} ${error.statusText}`
    : error instanceof Error
      ? error.message
      : String(error);
  const stack = error instanceof Error ? error.stack : undefined;

  return (
    <Box p={3} maxWidth={760} mx="auto">
      <Alert severity="error" sx={{ mb: 2 }}>
        <Typography fontWeight={700}>Error</Typography>
        <Typography variant="body2">{message}</Typography>
      </Alert>
      {stack && (
        <Box component="pre" sx={{ fontSize: 11, whiteSpace: 'pre-wrap', bgcolor: '#f3f4f6', p: 2, borderRadius: 2, overflow: 'auto' }}>
          {stack}
        </Box>
      )}
      <Button variant="contained" onClick={() => navigate('/')}>← Home</Button>
    </Box>
  );
}
